<div class="formulaWarningModal">
  <span class="formulaWarningModalText">
    {{ 'cf_import_formula_error' | ppTranslate }}
  </span>
</div>
